import { Tag } from "primereact/tag";

import TiposIcon from "@/assets/icons/revisao-tipos.svg?react";
import { REVISAO } from "../../../nova-obra.constants";
import styles from "../../etapa-revisao.module.scss";
import { Campo } from "../campo";
import { Secao } from "../secao";
import { TipoRevisao } from "./components/tipo-revisao";
import type { SecaoTiposObraProps, SecaoTiposObraViewModel } from "./types-secao-tipos-obra";

export function SecaoTiposObraView(props: SecaoTiposObraProps & SecaoTiposObraViewModel) {
  const { centroPrincipal, tipos, centrosAdicionais, onEditar } = props;

  return (
    <Secao id="tipos-obra" Icone={TiposIcon} titulo={REVISAO.secoes.tiposObra} onEditar={onEditar}>
      <Campo
        rotulo={REVISAO.tipos.centroCusto}
        valor={centroPrincipal ?? REVISAO.tipos.semCentro}
        testId="revisao-centro-principal"
      />
      <div className={`${styles.linha} ${styles.linhaDupla}`}>
        {/* Sem origem de dados no wizard/core para Unidade de Negócio e Empresa (Impasse 11). */}
        <Campo rotulo={REVISAO.tipos.unidadeNegocio} valor={REVISAO.vazio} />
        <Campo rotulo={REVISAO.tipos.empresa} valor={REVISAO.vazio} />
      </div>

      <h4 className={styles.subtitulo}>{REVISAO.tipos.tipos(tipos.length)}</h4>
      {tipos.length === 0 ? (
        <p className={styles.campoValor}>{REVISAO.tipos.semTipos}</p>
      ) : (
        tipos.map((item) => (
          <TipoRevisao
            key={item.tipo.uid}
            tipo={item.tipo}
            nome={item.nome}
            dominante={item.dominante}
          />
        ))
      )}

      {centrosAdicionais.length > 0 && (
        <>
          <h4 className={styles.subtitulo}>
            {REVISAO.tipos.outrosCentros(centrosAdicionais.length)}
          </h4>
          {centrosAdicionais.map((adicional) => (
            <div
              key={adicional.uid}
              className={styles.centroAdicional}
              data-testid="revisao-centro-adicional"
            >
              <div className={styles.centroAdicionalCabecalho}>
                <Tag severity="secondary" value={adicional.natureza} />
                {adicional.rotulo}
              </div>
              {adicional.tipos.map((item) => (
                <TipoRevisao
                  key={item.tipo.uid}
                  tipo={item.tipo}
                  nome={item.nome}
                  dominante={item.dominante}
                />
              ))}
            </div>
          ))}
        </>
      )}
    </Secao>
  );
}
